/**
 * useAnimationFrame hook
 * Returns current timestamp, updating on every animation frame when enabled
 * Optimized for smooth UI animations
 */

import { useEffect, useState } from 'react'

/**
 * Hook that returns the current timestamp, updating every animation frame
 * @param enabled - Whether to run the animation loop
 * @returns Current timestamp (Date.now())
 */
export function useAnimationFrame(enabled: boolean): number {
  const [now, setNow] = useState(Date.now())

  useEffect(() => {
    if (!enabled) {
      return
    }

    let rafId: number

    const tick = () => {
      setNow(Date.now())
      rafId = requestAnimationFrame(tick)
    }

    rafId = requestAnimationFrame(tick)

    return () => {
      cancelAnimationFrame(rafId)
    }
  }, [enabled])

  return now
}
